
import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'app/store/store'
import { ITaskInfo, ITaskState, IStatusHistory, IFiles, ITaskMessages, ICreateMessage, IApproveTask } from './types/Task-interface'

const taskNewState = (state: RootState): ITaskState => state.taskNew

export const TaskInfo = createSelector(
    [taskNewState],
    (state): ITaskInfo => state.TaskInfo,
)
export const isLoadingTaskInfo = createSelector(
    [taskNewState],
    (state): boolean => state.TaskInfo.isLoadingTaskInfo,
)
export const StatusHistory = createSelector(
    [taskNewState],
    (state): IStatusHistory => state.StatusHistory,
)
export const TaskMessages = createSelector(
    [taskNewState],
    (state): ITaskMessages => state.TaskMessages,
)
export const isLoadingTaskMessages = createSelector(
    [taskNewState],
    (state): boolean => state.TaskMessages.isLoadingTaskMessages,
)
export const Files = createSelector(
    [taskNewState],
    (state): IFiles => state.Files,
)
export const isLoadingFiles = createSelector(
    [taskNewState],
    (state): boolean => state.Files.isLoadingFiles,
)
export const ApproveTask = createSelector(
    [taskNewState],
    (state): IApproveTask => state.ApproveTask,
)
export const isLoadingApproveTask = createSelector(
    [taskNewState],
    (state): boolean => state.ApproveTask.isLoadingApproveTask,
)
export const TaskID = createSelector(
    [taskNewState],
    (state): string => state.TaskID,
)
export const Download = createSelector(
    [taskNewState],
    (state): boolean => state.isDownload,
)
export const ErrorDownload = createSelector(
    [taskNewState],
    (state): string[] => state.errorDownload,
)
export const FileData = createSelector(
    [taskNewState],
    (state): string => state.FileData,
)
export const FileName = createSelector(
    [taskNewState],
    (state): string => state.FileName,
)
export const selectIsLoading = createSelector(
    [taskNewState],
    (state): number => state.activeRequestsCount,
)

export const CreateMessage = createSelector(
    [taskNewState],
    (state): ICreateMessage => state.CreateMessage,
)
export const isLoadingCreateMessage = createSelector(
    [taskNewState],
    (state): boolean => state.CreateMessage.isLoadingCreateMessage,
)
